module.exports = __webpack_public_path__ + "img/em_mockup_04.1359d5bb.png";